
export enum WindowID {
    EmailInbox = "MailWindow",
    InternetTraveller = "InternetWindow",
    SettingsWindow = "SettingsWindow",
    SelectACaseWindow = "SelectACaseWindow",
    MailPopoutWindow = "MailPopoutWindow",
    DoctorStatsWindow = "DoctorStatsWindow",
    DoctOSWindow = "DoctOSWindow",
    MessagingContactsWindow = "DSNMessagingMainWindow",
    MessagingWindow = "DSNMessagingMainWindow",
}